export function findSubscription(cpf){
    return {
        type: 'FIND_SUBSCRIPTION',
        payload: cpf
    }
}

export function setSubscription(submissoes){
    return{
        type: 'SET_SUBSCRIPTIONS',
        payload: submissoes
    }
}


// WEBPACK FOOTER //
// ./src/view/inicio/acoes/MySubscriptionsActions.js